import {normalizeActionHandler} from './normalizeActionHandler';

export function mergeEventActionHandlers(actionHandlers, eventHandlers, tagName) {
	const {length: eventHandlerCount} = eventHandlers;
	for (let i = 0; i < eventHandlerCount; i++) {
		const {
			events = [],
			effect,
			modifiers = [],
			modifier = {},
			interceptors = [],
			target,
			capture,
			behaviorOptions
		} = eventHandlers[i];
		const {length: eventsCount} = events;
		for (let j = 0; j < eventsCount; j++) {
			const eventName = events[j];
			actionHandlers[eventName] = actionHandlers[eventName] || []; // eslint-disable-line no-param-reassign
			const normalizedActionHandler = {
				...normalizeActionHandler(
					{effect, modifiers, modifier, interceptors, target, capture, eventHandler: true},
					tagName
				),
				...(behaviorOptions && {behaviorOptions})
			};
			actionHandlers[eventName].push(normalizedActionHandler);
		}
	}

	return actionHandlers;
}
